import {Spinner, SpinnerSize, Tab} from "@blueprintjs/core";
import { useApiEffect } from "nsitools-react";
import * as React from "react";
import { useHistory, useParams } from "react-router";

import { CompetitionApi, ERequestType, RequestApi } from "../../../../api";
import { ERoutes } from "../../../../ERoutes";
import { BackButton, PageBase, ProtectedTabs } from "../../../../components";
import { useGlobalData } from "../../../../contexts";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { CompetitionDetail } from "./CompetitionDetail";
import { CompetitionResultImportPanel } from "./CompetitionResultImportPanel";
import { MailLogListPage } from "../../../mail-log/MailLogListPage";

export interface ICompetitionItemPageProps {}

export const CompetitionItemPage: React.FunctionComponent<ICompetitionItemPageProps> = (props) => {
  const { t } = useTl();
  const { id, tab, state = "edit" } = useParams<{ id: string; tab: string; state: string }>();

  const competitionId = React.useMemo(() => +id, [id]);
  const history = useHistory();
  const api = useApiService(CompetitionApi);
  const requestApi = useApiService(RequestApi);
  const { currentLanguage } = useGlobalData();

  const [displayName, loading] = useApiEffect(
    () => api.getDisplayName(competitionId, currentLanguage.languageId),
    [competitionId],
  );
  const [requestInfo, requestInfoLoading, , refreshRequestInfo] = useApiEffect(
    () => requestApi.getRequestInfo(ERequestType.WorkAttestRequest, +id, 0, currentLanguage.languageId),
    [requestApi, id, currentLanguage],
  );

  return (
    <PageBase
      breadCrumbs={[
        { text: t(ETLCodes.Competitions), route: ERoutes.competition },
        { text: competitionId > 0 ? loading ? <Spinner size={SpinnerSize.SMALL} /> : displayName : t(ETLCodes.New) },
      ]}
    >
      <ProtectedTabs
        id="TabsCompetition"
        onChange={(newTabId) => history.push(`${ERoutes.competition}/${id}/${newTabId}/${state}`)}
        selectedTabId={tab}
        renderActiveTabPanelOnly
      >
        <BackButton backRoute={ERoutes.competition} />
        <Tab
          id="detail"
          title={t(ETLCodes.Detail)}
          panel={<CompetitionDetail competitionId={competitionId} editMode={state === "edit"} />}
        />
        <Tab
          id="import"
          title={t(ETLCodes.Import)}
          panel={<CompetitionResultImportPanel competitionId={competitionId} />}
        />
        <Tab
          id="mailing"
          title={t(ETLCodes.Email)}
          panel={requestInfoLoading ? <Spinner /> : <MailLogListPage requestId={requestInfo?.parentRequestId} />}
          disabled={+id <= 0}
        />
      </ProtectedTabs>
    </PageBase>
  );
};
